import React from 'react';
import { FileUtils } from '../../../types/file';
import Icon, { IconType } from '../../icons/Icon';
import { Feedback } from '../Feedback/feedback';
import { ProgressBarWithFeedback } from '../Progressbar';

interface FileItemProps {
  file: {
    name: string;
    size: number;
  };
  onRemove?: () => void;
}

export default function FileItem({ file, onRemove }: FileItemProps) {
  return (
    <div className='flex flex-col gap-1 rounded-2 border border-black border-opacity-65 px-4 py-2.5'>
      <div className='flex gap-4'>
        <Icon type={IconType.file4} stroke={'stroke-black'} className={'self-center'} />
        <div className='flex-grow overflow-hidden'>
          <p className='text-sm font-medium text-black'>{file.name}</p>
          <p className='text-xs text-gray-500'>{FileUtils.fileSizeToFormattedString(file.size, 1)}</p>
        </div>
        {onRemove && <Icon type={IconType.xClose} stroke={'stroke-gray-500'} onClick={onRemove} size={'h-5 w-5'} />}
      </div>
      <div>
        <ProgressBarWithFeedback progress={1} feedback={{ type: Feedback.Type.success }} />
      </div>
    </div>
  );
}
